import { render } from "./AppPurchase.vue?vue&type=template&id=c9b58574"
import script from "./AppPurchase.vue?vue&type=script&lang=js"
export * from "./AppPurchase.vue?vue&type=script&lang=js"

import "./AppPurchase.vue?vue&type=style&index=0&id=c9b58574&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__